'use client';

import { c as _c } from "react/compiler-runtime";
import './honor-card-builder.scss';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Select } from '@sola/ark-core/molecules/select/select.tsx';
import { TextArea } from '@sola/ark-core/molecules/text-area/text-area.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { DesignPalette } from '../../molecules/honor-card-design-palette/honor-card-design-palette.tsx';
import { HonorCard } from '../../molecules/honor-card/honor-card.tsx';
import { ShareButtons } from '../../molecules/share-buttons/share-buttons.tsx';
import { useHonorCardBuilder } from './honor-card-builder.logic.ts';
const HonorCardBuilderInner: React.FC = () => {
  const $ = _c(118);
  const {
    coverCategory,
    coverNumber,
    giftId,
    selectedGift,
    personalNote,
    setCoverCategory,
    setCoverNumber,
    setGiftId,
    setPersonalNote,
    coverCategories,
    coverNumbers,
    giftOptions,
    handleDownloadPdf,
    handleEmailCard,
    handleViewCard,
    shareUrl
  } = useHonorCardBuilder();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["honor-card"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("honor-card:title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h1 className="heading-lg heading-neutral-amplified mb-comfy-sm">{t1}</h1>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("honor-card:subtitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="label-moderate label-lg mb-comfy-lg">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("honor-card:cardType");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== setCoverCategory) {
    t6 = e => setCoverCategory(e.target.value);
    $[11] = setCoverCategory;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== coverCategories || $[14] !== coverCategory || $[15] !== t5 || $[16] !== t6) {
    t7 = <Select isFocused={true} items={coverCategories} label={t5} name="cover-category-select" onChange={t6} value={coverCategory} required={true} />;
    $[13] = coverCategories;
    $[14] = coverCategory;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("honor-card:design");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== coverNumber || $[21] !== coverNumbers || $[22] !== setCoverNumber || $[23] !== t8) {
    t9 = <DesignPalette label={t8} value={coverNumber} options={coverNumbers} onChange={setCoverNumber} />;
    $[20] = coverNumber;
    $[21] = coverNumbers;
    $[22] = setCoverNumber;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("honor-card:giftGiven");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== setGiftId) {
    t11 = e_0 => setGiftId(e_0.target.value);
    $[27] = setGiftId;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== giftId || $[30] !== giftOptions || $[31] !== t10 || $[32] !== t11) {
    t12 = <Select isFocused={true} items={giftOptions} label={t10} name="gift-select" onChange={t11} value={giftId} required={true} />;
    $[29] = giftId;
    $[30] = giftOptions;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t) {
    t13 = t("honor-card:personalMessage");
    $[34] = t;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t) {
    t14 = t("honor-card:letterPlaceholder");
    $[36] = t;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== setPersonalNote) {
    t15 = e_1 => setPersonalNote(e_1.target.value);
    $[38] = setPersonalNote;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== personalNote || $[41] !== t13 || $[42] !== t14 || $[43] !== t15) {
    t16 = <TextArea label={t13} name="personal-note" placeholder={t14} defaultValue={personalNote} onChange={t15} maxLength={500} rows={7} />;
    $[40] = personalNote;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t12 || $[46] !== t16 || $[47] !== t7 || $[48] !== t9) {
    t17 = <div className="flex flex-col mb-comfy-md">{t7}{t9}{t12}{t16}</div>;
    $[45] = t12;
    $[46] = t16;
    $[47] = t7;
    $[48] = t9;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const t18 = selectedGift?.label;
  const t19 = selectedGift?.message;
  let t20;
  if ($[50] !== coverCategory || $[51] !== coverNumber || $[52] !== personalNote || $[53] !== t18 || $[54] !== t19) {
    t20 = <HonorCard variant="preview" coverCategory={coverCategory} coverNumber={coverNumber} giftLabel={t18} giftMessage={t19} personalNote={personalNote} />;
    $[50] = coverCategory;
    $[51] = coverNumber;
    $[52] = personalNote;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t) {
    t21 = t("honor-card:view");
    $[56] = t;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== handleViewCard || $[59] !== t21) {
    t22 = <ButtonStyle variant="primary" size="lg"><button type="button" onClick={handleViewCard}>{t21}</button></ButtonStyle>;
    $[58] = handleViewCard;
    $[59] = t21;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== t) {
    t23 = t("honor-card:readyToSend");
    $[61] = t;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== t23) {
    t24 = <h2 className="heading-sm heading-neutral-amplified">{t23}</h2>;
    $[63] = t23;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] !== t) {
    t25 = t("honor-card:deliverYourself");
    $[65] = t;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== t25) {
    t26 = <h4 className="w-full col-span-full">{t25}</h4>;
    $[67] = t25;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== handleEmailCard || $[70] !== t) {
    t27 = () => handleEmailCard(t("honor-card:shareTitle"), t("honor-card:shareSummary"));
    $[69] = handleEmailCard;
    $[70] = t;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== t) {
    t28 = t("honor-card:email");
    $[72] = t;
    $[73] = t28;
  } else {
    t28 = $[73];
  }
  let t29;
  if ($[74] !== t28) {
    t29 = <ArkIcon iconName="mail-01" alt={t28} />;
    $[74] = t28;
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  let t30;
  if ($[76] !== t) {
    t30 = t("honor-card:email");
    $[76] = t;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== t27 || $[79] !== t29 || $[80] !== t30) {
    t31 = <ButtonStyle variant="primary" size="lg"><button type="button" onClick={t27}>{t29}{t30}</button></ButtonStyle>;
    $[78] = t27;
    $[79] = t29;
    $[80] = t30;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  let t32;
  if ($[82] !== t) {
    t32 = t("honor-card:shareTitle");
    $[82] = t;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== t) {
    t33 = t("honor-card:shareSummary");
    $[84] = t;
    $[85] = t33;
  } else {
    t33 = $[85];
  }
  let t34;
  if ($[86] !== t) {
    t34 = t("honor-card:shareOnline");
    $[86] = t;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  let t35;
  if ($[88] !== shareUrl || $[89] !== t32 || $[90] !== t33 || $[91] !== t34) {
    t35 = <ShareButtons shareUrl={shareUrl} shareTitle={t32} shareSummary={t33} buttonLabel={t34} size="lg" />;
    $[88] = shareUrl;
    $[89] = t32;
    $[90] = t33;
    $[91] = t34;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  let t36;
  if ($[93] !== t) {
    t36 = t("honor-card:print");
    $[93] = t;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  let t37;
  if ($[95] !== t36) {
    t37 = <ArkIcon iconName="book-open-01" alt={t36} />;
    $[95] = t36;
    $[96] = t37;
  } else {
    t37 = $[96];
  }
  let t38;
  if ($[97] !== t) {
    t38 = t("honor-card:print");
    $[97] = t;
    $[98] = t38;
  } else {
    t38 = $[98];
  }
  let t39;
  if ($[99] !== handleDownloadPdf || $[100] !== t37 || $[101] !== t38) {
    t39 = <ButtonStyle variant="secondary" size="lg"><button type="button" onClick={handleDownloadPdf}>{t37}{t38}</button></ButtonStyle>;
    $[99] = handleDownloadPdf;
    $[100] = t37;
    $[101] = t38;
    $[102] = t39;
  } else {
    t39 = $[102];
  }
  let t40;
  if ($[103] !== t26 || $[104] !== t31 || $[105] !== t35 || $[106] !== t39) {
    t40 = <div className="flex flex-wrap gap-snug-lg">{t26}{t31}{t35}{t39}</div>;
    $[103] = t26;
    $[104] = t31;
    $[105] = t35;
    $[106] = t39;
    $[107] = t40;
  } else {
    t40 = $[107];
  }
  let t41;
  if ($[108] !== t22 || $[109] !== t24 || $[110] !== t40) {
    t41 = <div className="flex flex-col gap-comfy-md mt-snug-lg">{t22}{t24}{t40}</div>;
    $[108] = t22;
    $[109] = t24;
    $[110] = t40;
    $[111] = t41;
  } else {
    t41 = $[111];
  }
  let t42;
  if ($[112] !== t17 || $[113] !== t2 || $[114] !== t20 || $[115] !== t4 || $[116] !== t41) {
    t42 = <section className="HonorCardBuilder">{t2}{t4}{t17}{t20}{t41}</section>;
    $[112] = t17;
    $[113] = t2;
    $[114] = t20;
    $[115] = t4;
    $[116] = t41;
    $[117] = t42;
  } else {
    t42 = $[117];
  }
  return t42;
};
export const HonorCardBuilder: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense><HonorCardBuilderInner /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};